module.exports = __webpack_public_path__ + "static/who-was-walt-disney-808b028820610982f601ba8d704ed91f.jpg";